import { useTranslation } from "react-i18next";

import { Tag, TagProps, TagVariant } from "@industriousoffice/react-components";

interface AutoPayTagProps extends Omit<TagProps, "text"> {
  isAutoPayOn: boolean;
  hasDefaultPaymentMethod: boolean;
}

function AutoPayTag({
  isAutoPayOn,
  hasDefaultPaymentMethod = true,
  ...rest
}: AutoPayTagProps) {
  const { t } = useTranslation();

  const getVariant = () => {
    if (!hasDefaultPaymentMethod) {
      return TagVariant.Error;
    }
    return isAutoPayOn ? TagVariant.Positive : TagVariant.Default;
  };

  const getText = () => {
    if (!hasDefaultPaymentMethod) {
      return t("Payment Method Missing");
    }
    return t(isAutoPayOn ? "Auto-Pay On" : "Auto-Pay Off");
  };

  return (
    <Tag
      variant={getVariant()}
      text={getText()}
      testId="autopay-tag"
      {...rest}
    />
  );
}

export default AutoPayTag;
